<template>
	<div>
		<statistci-marketing></statistci-marketing>
	</div>
</template>
<script>
import StatistciMarketing from '@/components/payment/statistic/marketing'
export default {
	components: {
		StatistciMarketing
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/front.vue